import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import _find from 'lodash/find';
import {flowRight as compose} from 'lodash';

import EstaSeguro from '../../../components/funcionales/estaseguro'

//utils
import queries from '../../../utils/queries'

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.claseserv._id} value={props.elemento._id} style={props.style.input}>{props.elemento.claseserv.codigoClaseServ}: {props.elemento.claseserv.descrClaseServ} ={">"} {props.elemento.codigoSubclaseServ}: {props.elemento.descrSubclaseServ}</option>
  )
};

const Lista = ({style, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 style={style} elemento={elemento} key={elemento._id} />);
  return(
  <div>
    <select style={style.input} className="ui simple selection dropdown fluid" name="subclaseserv" id="miLista" value={permiteUpdate?argsDocum._idSubclaseServ:idLista.subclaseserv._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
      {Nivel1Detalle}
    </select>
  </div>
  )
};

const DetalleNivelTT = props => {
  return (
    <option dato1={props.elemento.descrTipoTec} value={props.elemento.codigoTipoTec} style={props.style.input}>{props.elemento.codigoTipoTec} ={">"} {props.elemento.descrTipoTec}</option>
  )
};

const ListaTT = ({style, list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelTT style={style} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={style.input} className="ui simple selection dropdown fluid" name="tipotec" id="miListaTT" value={permiteUpdate?argsDocum.codigoTipoTec:idLista.codigoTipoTec} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const ListaDXMas = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="paraProcMasDX" id="miLista7" value={permiteUpdate?argsDocum.paraProcMasDX:idLista.paraProcMasDX} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>SI</option>
        <option>NO</option>
      </select>
    </div>
  )
};

class VerSer2 extends React.Component {
  state={
    argsDocum: {codigoServicio: this.props.idLista.codigoServicio,
                nombreResumido: this.props.idLista.nombreResumido,
                descripcionServicio: this.props.idLista.descripcionServicio,
                conceptoEnFra: this.props.idLista.conceptoEnFra,
                consecEnFra: this.props.idLista.consecEnFra,
                _idSubclaseServ: this.props.idLista.subclaseserv._id,
                codigoSubclaseServ: this.props.idLista.subclaseserv.codigoSubclaseServ,
                descrSubclaseServ: this.props.idLista.subclaseserv.descrSubclaseServ,
                _idClaseServ: this.props.idLista.subclaseserv.claseserv._id,
                codigoClaseServ: this.props.idLista.subclaseserv.claseserv.codigoClaseServ,
                descrClaseServ: this.props.idLista.subclaseserv.claseserv.descrClaseServ,
                velEfecDownstream: this.props.idLista.velEfecDownstream,
                velEfecUpstream: this.props.idLista.velEfecUpstream,
                codigoTipoTec: this.props.idLista.codigoTipoTec,
                descrTipoTec: this.props.idLista.descrTipoTec,
                colorServicio: this.props.idLista.colorServicio,
                paraProcMasDX: this.props.idLista.paraProcMasDX,
                _id: this.props.idLista._id},
    confirmaAct: false,
    open: false
  }

  handleChange = (ev) => {
    // console.log(ev.target.name, ev.target.value)
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      if(ev.target.name !== "codigoServicio"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "subclaseserv"){
          //No se permite modificar la subclase => se comentan las lineas siguientes
          // argsDocum['_idSubclaseServ'] = ev.target.value
          // var miLista = document.getElementById("miLista");
          // argsDocum['codigoClaseServ'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
          if(ev.target.name === "tipotec"){
            argsDocum['codigoTipoTec'] = ev.target.value
            let miLista = document.getElementById("miListaTT");
            argsDocum['descrTipoTec'] = miLista.options[miLista.selectedIndex].attributes[0].value
        }else{
            if(ev.target.name === "paraProcMasDX"){
              let miLista = document.getElementById("miLista7");
              argsDocum['paraProcMasDX'] = miLista.options[miLista.selectedIndex].text
            }else{
              argsDocum[ev.target.name] = ev.target.value 
            }
          }
        }
        this.setState({argsDocum});
      }
    }  
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, confirmaAct, open} = this.state;
    let listaCSubCl = [], listTT = []
    if(this.props.allSubclasesServ.allSubclasesServ){listaCSubCl = this.props.allSubclasesServ.allSubclasesServ}
    if(this.props.allTipoTec.allTipoTec){listTT = this.props.allTipoTec.allTipoTec}
    // console.log(this.props.allSubclasesServ.allSubclasesServ)
    // console.log(listaCSubCl)
    // console.log(argsDocum)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large hand point down yellow icon"></i>
            Servicio
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Código</label>
                        <input style={this.props.styles.input} autoComplete="off" name="codigoServicio" id="codigoServicio" value={argsDocum.codigoServicio} onChange={this.handleChange} placeholder='Código'  icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codigoServicio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                      <Form.Field>
                        <label style={this.props.styles.label}>Descripción resumida</label>
                        <input style={this.props.styles.input} autoComplete="off" name="nombreResumido" id="nombreResumido" value={this.props.permiteUpdate?argsDocum.nombreResumido:this.props.idLista.nombreResumido} onChange={this.handleChange} placeholder='Descripción resumida' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'nombreResumido'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <input style={this.props.styles.input} autoComplete="off" name="descripcionServicio" id="descripcionServicio" value={this.props.permiteUpdate?argsDocum.descripcionServicio:this.props.idLista.descripcionServicio} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descripcionServicio'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Concepto en factura</label>
                          <input style={this.props.styles.input} autoComplete="off" name="conceptoEnFra" id="conceptoEnFra" value={this.props.permiteUpdate?argsDocum.conceptoEnFra:this.props.idLista.conceptoEnFra} onChange={this.handleChange} placeholder='Concepto en factura' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'conceptoEnFra'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Consecutivo en factura</label>
                          <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="consecEnFra" id="consecEnFra" value={this.props.permiteUpdate?argsDocum.consecEnFra:this.props.idLista.consecEnFra} placeholder='Consecutivo en factura' onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>

                  <Form.Field>
                    <label style={this.props.styles.label}>Subclase</label>
                    <Lista list={listaCSubCl} style={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>

                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Velocidad efectiva Downstream</label>
                          <input type='number' step="0.1" min="0" style={this.props.styles.input} autoComplete="off" name="velEfecDownstream" id="velEfecDownstream" value={this.props.permiteUpdate?argsDocum.velEfecDownstream:this.props.idLista.velEfecDownstream} placeholder='Velocidad efectiva Downstream' onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '25%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Velocidad efectiva Upstream</label>
                          <input type='number' step="0.1" min="0" style={this.props.styles.input} autoComplete="off" name="velEfecUpstream" id="velEfecUpstream" value={this.props.permiteUpdate?argsDocum.velEfecUpstream:this.props.idLista.velEfecUpstream} placeholder='Velocidad efectiva Upstream' onChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <Form.Field>
                          <label style={this.props.styles.label}>Tipo de Tecnología</label>
                          <ListaTT list={listTT} style={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>

                  <Form.Field>
                    <label style={this.props.styles.label}>Color para distinguir en Clientes</label>
                    <input style={{width: '25%'}} type='color' value={this.props.permiteUpdate?argsDocum.colorServicio:this.props.idLista.colorServicio} name="colorServicio" id="colorServicio" onChange={this.handleChange}/>
                  </Form.Field>

                  <Form.Field>
                    <label style={this.props.styles.label}>Seleccionar en proceso de DX masivas:</label>
                    <ListaDXMas styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>

                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

// export default VerSer2
// export default graphql(queries.query.allSubclasesServ, {options: (props) => {return {variables: {}}}})(VerSer2)

export default compose(
  graphql(queries.query.allSubclasesServ, {name:'allSubclasesServ', options: () => {return {variables: {}}}}),
  graphql(queries.query.allTipoTec, {name:'allTipoTec', options: () => {return {variables: {}}}}),
)(VerSer2)
